let is_changed = false;
let is_submitted = false;

export function check_if_unsaved() {
    const form_selector = document.querySelector("form[data-check-unsaved]");

    if (form_selector) {
        const inputs = form_selector.querySelectorAll("input");
        const checkboxs = form_selector.querySelectorAll(
            "input[type=checkbox]"
        );
        const selects = form_selector.querySelectorAll("select");
        const buttons = form_selector.querySelectorAll("button[type=submit]");

        const textareas = form_selector.querySelectorAll("textarea");
        if (inputs.length) {
            inputs.forEach((input) => {
                input.addEventListener("input", () => {
                    console.log("input");
                    is_changed = true;
                });

                input.addEventListener("change", () => {
                    console.log("change");
                    is_changed = true;
                });

                input.addEventListener("changeDate", () => {
                    console.log("change date");
                    is_changed = true;
                });
            });
        }

        if (selects.length) {
            selects.forEach((select) => {
                select.addEventListener("change", () => {
                    is_changed = true;
                });
            });
        }

        if (checkboxs.length) {
            checkboxs.forEach((checkbox) => {
                checkbox.addEventListener("change", () => {
                    is_changed = true;
                });
            });
        }

        if (textareas.length) {
            textareas.forEach((textarea) => {
                textarea.addEventListener("input", () => {
                    is_changed = true;
                });

                textarea.addEventListener("change", () => {
                    is_changed = true;
                });
            });
        }

        window.addEventListener("beforeunload", (e) => {
            console.log("beforeunload");
            console.log("is_changed", is_changed);
            console.log("is_submitted", is_submitted);
            if (is_changed && !is_submitted) {
                e.preventDefault();
                e.returnValue = "You have unsaved changes";
            }
        });

        if (buttons.length) {
            buttons.forEach((btn) => {
                btn.addEventListener("click", () => {
                    is_submitted = true;
                });
            });
        }

        form_selector.addEventListener("submit", (e) => {
            set_is_submitted();
        });
    }
}

export function set_is_changed() {
    is_changed = true;
}

export function set_is_submitted() {
    is_submitted = true;
}

document.addEventListener("DOMContentLoaded", () => {
    check_if_unsaved();
});
